import CategoriesHero from "../components/categories/CategoriesHero";
import CategoryBrowseGroups from "../components/categories/CategoryBrowseGroups";
import NewsletterBanner from "../components/shared/NewsletterBanner";
import useSEO from "../hooks/useSEO";

export default function CategoriesPage() {
  const seo = useSEO({});

  return (
    <>
      {seo}
      <CategoriesHero />
      <CategoryBrowseGroups />
      <NewsletterBanner />
    </>
  );
}
